import type { RideType } from '@/types';

export const rideOptions: RideType[] = [
	{
		category: 'Standard',
		rides: [
			{
				name: 'Moto',
				description:
					'Includes mototaxis with drivers and vehicles screened by Xpress',
				icon: '/images/Icon=Moto, Size=40x40.png',
				value: 'motorcycle',
			},
			{
				name: 'Sedan',
				description:
					'Includes taxis with drivers and vehicles screened by Xpress',
				icon: '/images/Icon=Car, Size=40x40.png',
				value: 'sedan',
			},
			{
				name: 'SUV',
				description: 'Affordable rides for groups up to 6',
				icon: '/images/Icon=SUV, Size=40x40.png',
				value: 'suv',
			},
		],
	},
	{
		category: 'Miscellaneous',
		rides: [
			{
				name: 'Item delivery',
				description: 'Standard packages delivery',
				icon: '/images/svg/box.svg',
				value: 'item-delivery',
			},
		],
	},
];

export const TRAVEL_LOCATION_CATEGORIES = [
	{
		label: 'To Permitted Locations',
		value: 'to-permitted-locations',
	},
	{
		label: 'Between Permitted Locations',
		value: 'between-permitted-locations',
	},
	{
		label: 'From the Permitted Locations',
		value: 'from-permitted-locations',
	},
	{
		label: 'To or from the permitted locations',
		value: 'to-or-from-permitted-locations',
	},
];

export const RADIUS_OPTIONS = [
	{ label: '1.5km', value: 1.5 },
	{ label: '2km', value: 2 },
	{ label: '3km', value: 3 },
	{ label: '1km', value: 1 },
	{ label: '1.5km', value: 1.5 },
	{ label: '2km', value: 2 },
	{ label: '3km', value: 3 },
];

export const TRAVEL_DAYS_OF_THE_WEEK = [
	{
		label: 'Mon',
		value: 'monday',
	},
	{
		label: 'Tue',
		value: 'tuesday',
	},
	{
		label: 'Wed',
		value: 'wednesday',
	},
	{
		label: 'Thu',
		value: 'thursday',
	},
	{
		label: 'Fri',
		value: 'friday',
	},
	{
		label: 'Sat',
		value: 'saturday',
	},
	{
		label: 'Sun',
		value: 'sunday',
	},
];

export const TRAVEL_RIDE_SERVICE = {
	motorcycle: 'motorcycle',
	sedan: 'sedan',
	suv: 'suv',
	delivery: 'delivery',
};

export const TRAVEL_EXPENSE_CODE_TYPE = {
	none: 'none',
	required: 'required',
};

export const TRAVEL_LOCATION_TYPE = {
	any: 'any',
	limited: 'limited',
};

export const TRAVEL_TIME_TYPE = {
	'all-day': 'all-day',
	weekdays: 'weekdays',
	custom: 'custom',
};

export const TRAVEL_RIDE_TYPE = {
	all: 'all',
	limited: 'limited',
};
